export enum EnvironmentName {
  Dev,
  Test,
  Cld,
  Prod,
}
